import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { problems } from '../data/landing';
export function ProblemSection() {
  return <section className="w-full bg-white py-20 sm:py-28" aria-labelledby="problema-title" data-id="element-111" data-mp="2ltwctv8nioy5">
      <div className="mx-auto grid w-full max-w-6xl gap-14 px-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-112" data-mp="30hzhn1ayjuld">
        <div className="lg:sticky lg:top-16 lg:self-start" data-id="element-113" data-mp="2vowmioqj8d32">
          <h2 id="problema-title" className="font-serif text-3xl font-bold leading-tight text-[#0f172a] sm:text-4xl lg:text-5xl" data-id="element-114" data-mp="39hcrvw6won75">
            Comer sano en Argentina no debería{' '}
            <span className="text-[#dc2626]" data-id="element-115" data-mp="3jg23x8c4fdfh">arruinarte</span>
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-600" data-id="element-116" data-mp="3jdzb6gjl3672">
            El mercado está diseñado para que pagues más por menos. La Fit-Tax, el
            delivery de emergencia y los suplementos inútiles drenan tu presupuesto
            cada mes sin que te des cuenta.
          </p>
        </div>

        <ul className="grid gap-5 sm:grid-cols-2" data-id="element-117" data-mp="jd3pitjhulu2">
          {problems.map(problem => <li key={problem.title} className="rounded border-l-4 border-[#dc2626] bg-[#fef2f2] p-6" data-id="element-118" data-mp="jb0olegsz8ak">
              <div className="flex items-center gap-2" data-id="element-119" data-mp="oa3qiq1hkyeb">
                <AlertTriangleIcon className="h-4 w-4 text-[#dc2626]" aria-hidden="true" data-id="element-120" data-mp="scqnt6gxfbiw" />
                <h3 className="font-serif text-lg font-bold text-[#0f172a]" data-id="element-121" data-mp="x4s18vptz8ai">
                  {problem.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-slate-700" data-id="element-122" data-mp="125z6an0l9tdh">
                {problem.description}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}